import { GalleryType } from '../models';
import type { ActivityStaticData, ActivityDetailsHeaderData } from '../models';

export function getActivityDetailsHeaderData(
  activityStaticData: ActivityStaticData | undefined
): ActivityDetailsHeaderData | undefined {
  if (!activityStaticData) {
    return;
  }

  return {
    headerText: activityStaticData.staticInfo.name,
    starsAmount: activityStaticData.staticInfo.semboSunRating,
    subHeaderText: activityStaticData.destination,
  };
}

export function getGalleryType(isSmallDevice: boolean): GalleryType {
  return isSmallDevice ? GalleryType.Swiper : GalleryType.Masonry;
}
